<template>
  <highlight-dialog
    :title="dialogTitle"
    persistent
    @close="$emit('close')"
  >
    <div
      class="hl-download"
      :class="{ 'is-complete': isComplete, 'is-error': isError }"
    >
      <div class="hl-download-icon">
        <svg
          v-if="isError"
          class="hl-download-error"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
        </svg>
        <svg
          v-else-if="isComplete"
          class="hl-download-check"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
          />
        </svg>
        <svg
          v-else
          class="hl-download-arrow"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M12 3a1 1 0 0 1 1 1v9.59l3.3-3.3a1 1 0 1 1 1.4 1.42l-5 5a1 1 0 0 1-1.4 0l-5-5a1 1 0 1 1 1.4-1.42l3.3 3.3V4a1 1 0 0 1 1-1zm-7 16a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1z"
          />
        </svg>
        <span class="hl-download-ring" aria-hidden="true"></span>
      </div>
      <p class="hl-download-title">{{ video.title }}</p>
      <p class="hl-download-status">{{ statusText }}</p>
      <div
        class="hl-progress"
        role="progressbar"
        :aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div class="hl-progress-bar" :style="{ width: progress + '%' }"></div>
      </div>
      <div class="hl-download-stats">
        <span>{{ formattedBytes }}</span>
        <span>{{ progress }}%</span>
      </div>
    </div>
  </highlight-dialog>
</template>

<script>
import HighlightDialog from "./HighlightDialog.vue";
import { formatBytes } from "@/utils/eventHighlights";
import "@/assets/css/event-highlights.css";

export default {
  name: "HighlightDownloadDialog",
  components: { HighlightDialog },
  props: {
    video: { type: Object, required: true },
    progress: { type: Number, default: 0 },
    downloadedBytes: { type: Number, default: 0 },
    totalBytes: { type: Number, default: 0 },
    // 'downloading' | 'complete' | 'error'
    state: { type: String, default: "downloading" },
  },
  emits: ["close"],
  computed: {
    isComplete() {
      return this.state === "complete";
    },
    isError() {
      return this.state === "error";
    },
    dialogTitle() {
      if (this.isError) return "Download Failed";
      if (this.isComplete) return "Downloaded";
      return "Downloading";
    },
    statusText() {
      if (this.isError) {
        return "Download failed. Close this dialog and try again.";
      }
      if (this.isComplete) return "Completed";
      return "Downloading…";
    },
    formattedBytes() {
      if (this.totalBytes > 0) {
        return `${formatBytes(this.downloadedBytes)} / ${formatBytes(
          this.totalBytes
        )}`;
      }
      if (this.downloadedBytes > 0) return formatBytes(this.downloadedBytes);
      return "";
    },
  },
};
</script>
